import { template as template_a2fff078c91b48e4a454370e28d44a7a } from "@ember/template-compiler";
import PowerSelect from 'eflex/components/power-select';
import { t } from 'ember-intl';
export default template_a2fff078c91b48e4a454370e28d44a7a(`
<div class="component-bi-report-dropdown section-name d-flex align-items-center" ...attributes>
  <span class="fs-2 me-3">•</span>
  <PowerSelect
    @options={{@options}}
    @selected={{@selected}}
    @placeholder={{t "bi.nav.selectReport" }}
    @onChange={{@onChange}}
  as |navSelect|>
    {{t navSelect.label}}
  </PowerSelect>
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
